"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CheckboxFilterGroup: ()=>CheckboxFilterGroup
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const CheckboxFilter_cjs_namespaceObject = require("../../CheckboxFilter/CheckboxFilter.cjs");
const external_FilterGroupWrapper_cjs_namespaceObject = require("../FilterGroupWrapper.cjs");
function CheckboxFilterGroup({ title, options, groups, onReset, showMoreLimit, resettable = false, collapsible = false, defaultCollapsed = false, className = '', selectable = false, onSelectAll, onSelectNone, showMoreText }) {
    const filterGroups = groups?.map((group)=>({
            subtitle: group.subtitle,
            items: group.options,
            showMoreLimit: group.showMoreLimit,
            showMoreText: group.showMoreText,
            resettable: group.resettable,
            selectable: group.selectable,
            onSelectAll: group.onSelectAll,
            onSelectNone: group.onSelectNone,
            onReset: group.onReset
        }));
    const isAllSelected = options?.every((opt)=>opt.checked) || false;
    const isNoneSelected = options?.every((opt)=>!opt.checked) || false;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_FilterGroupWrapper_cjs_namespaceObject.FilterGroupWrapper, {
        title: title,
        collapsible: collapsible,
        defaultCollapsed: defaultCollapsed,
        showMoreLimit: showMoreLimit,
        resettable: resettable,
        onReset: onReset,
        className: className,
        selectable: selectable,
        onSelectAll: onSelectAll,
        onSelectNone: onSelectNone,
        isAllSelected: isAllSelected,
        isNoneSelected: isNoneSelected,
        items: options,
        groups: filterGroups,
        showMoreText: showMoreText,
        children: (visibleOptions)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "flex w-full flex-col gap-2",
                children: visibleOptions.map((opt)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: `flex w-full ${opt.nestedFilters ? '[&_label]:py-0' : ''}`,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CheckboxFilter_cjs_namespaceObject.CheckboxFilter, {
                            ...opt
                        })
                    }, opt.value))
            })
    });
}
exports.CheckboxFilterGroup = __webpack_exports__.CheckboxFilterGroup;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CheckboxFilterGroup"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
